import { DefaultError } from '@tanstack/query-core';
import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { useCurrentAccount } from './useCurrentAccount';
import { fetchAccountMemberRoles } from 'api/account';
import { accountQueryKeys } from 'queries/account-query-keys';
import { AccountMemberRoleInfo } from 'types/domain';
import { PaginatedData } from 'types/pagination';

const useAccountMemberRoles = (
    options: Omit<
        UseSuspenseQueryOptions<PaginatedData<AccountMemberRoleInfo>, DefaultError>,
        'queryKey' | 'queryFn'
    > = {},
) => {
    const { accountId } = useCurrentAccount();

    const params = {
        page: 1,
        limit: 100,
    };

    return useSuspenseQuery<PaginatedData<AccountMemberRoleInfo>, DefaultError>({
        queryKey: accountQueryKeys.accountMemberRoles(accountId),
        queryFn: () => fetchAccountMemberRoles(accountId, params),
        ...options,
    });
};

export { useAccountMemberRoles };
